import { useTheme } from '@mui/material';

export const QuickStudyIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={41} height={41} fill="none">
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeWidth={1.5}
                d="M3.833 36.779h18.334c8.284 0 15-6.716 15-15 0-8.285-6.716-15-15-15-7.721 0-14.171 5.833-15 13.333"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M31.333 9.279 33 7.612m-23.333 0 1.666 1.667"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeWidth={1.5}
                d="m28 15.112-4.899 4.899m0 0a2.5 2.5 0 1 0-3.536 3.536 2.5 2.5 0 0 0 3.536-3.536Z"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M21.333 5.945v-2.5m-3.333 0h6.667M3.833 25.112h5m-5 6.667h8.334"
            />
        </svg>
    );
};
